import { Experiment } from '@naturalcycles/shared'
import { QuizPage } from '@src/app/cnst/quiz/quiz-pages.cnst'
import { QuizModifier } from '@src/app/util/quiz.util'
import { QuizSections } from '@src/typings/quiz.enum'
import { AppQuizEngineConfig, AppQuizFlow, QuizSignatureObject } from '@src/typings/quiz.model'
import { fertilityGoalBreakpointClinicalResearchABTest } from './fertility-goal.breakpoint'

class ExpClinicalResearchReinforcementQuiz implements QuizModifier<AppQuizEngineConfig> {
  public _shouldEnhance(obj: QuizSignatureObject): boolean {
    return obj.experiment[Experiment.CLINICAL_RESEARCH_REINFORCEMENT] === 'test'
  }

  public enhanceEngineConfig(
    obj: QuizSignatureObject,
    config: AppQuizEngineConfig,
  ): AppQuizEngineConfig {
    if (!this._shouldEnhance(obj)) return config

    config.breakpointActions.goal = fertilityGoalBreakpointClinicalResearchABTest

    config.guardData = {
      ...config.guardData,
      [QuizPage.clinicalResearchReinforcementABTest]: state => !!state?.birthControlMethod,
    }

    return config
  }

  public enhanceSections(obj: QuizSignatureObject, sections: QuizSections): QuizSections {
    if (!this._shouldEnhance(obj)) return sections

    return sections
  }

  public enhanceInitialFlow(obj: QuizSignatureObject, flow: AppQuizFlow): AppQuizFlow {
    if (!this._shouldEnhance(obj)) return flow
    return flow
  }

  public enhanceEntry(obj: QuizSignatureObject, entry: QuizPage | null): QuizPage | null {
    if (!this._shouldEnhance(obj)) return entry
    return entry
  }

  public enhanceExit(obj: QuizSignatureObject, exit: QuizPage | null): QuizPage | null {
    if (!this._shouldEnhance(obj)) return exit
    return exit
  }
}

export const expClinicalResearchReinforcementABTest = new ExpClinicalResearchReinforcementQuiz()
